type Lockable = {
  lockedAmount?: boolean
  lockedAmountUnit?: string
  symbol?: string
  instrumentName?: string
  side?: string
  tradeSide?: string
}

/**
 * A close-position row's size is locked only while the row is still that close. When an edit
 * changes its symbol or side it is a different order, so the lock is dropped.
 */
export function lockAfterEdit<T extends Lockable>(prev: T, next: T): T {
  if (!prev.lockedAmount) return next
  const symbolChanged =
    (prev.symbol ?? prev.instrumentName) !== (next.symbol ?? next.instrumentName)
  const sideChanged = (prev.tradeSide ?? prev.side) !== (next.tradeSide ?? next.side)
  return symbolChanged || sideChanged
    ? { ...next, lockedAmount: undefined, lockedAmountUnit: undefined }
    : next
}

/** A locked close owns its size and unit; ordinary row edits preserve the user's inputs. */
export function mergeRowAmount<
  T extends {
    amount?: string
    amountUnit?: string
    lockedAmount?: boolean
  },
>(next: T, current: T): T {
  return next.lockedAmount
    ? next
    : { ...next, amount: current.amount, amountUnit: current.amountUnit || next.amountUnit }
}
